// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .receivable-select-row table tbody .payment-pending td {\n  cursor: pointer !important;\n}\n[dir=ltr] .check-td {\n  padding-left: 14px !important;\n}\n[dir=rtl] .check-td {\n  padding-right: 14px !important;\n}", ""]);
// Exports
module.exports = exports;
